import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./element/Button";
import { ControlGroup } from "./layout/ControlGroup";
import { useMap } from "../hooks";
import { useEffect, useState } from "react";
import { ZoomIn } from "../constants/icons/ZoomIn";
import { ZoomOut } from "../constants/icons/ZoomOut";
import { InnerButton } from "./element/InnerButton";

export const ZoomFeature = () => {
  const { t } = useTranslation("timeSeries");
  const map = useMap();
  const [zoomAmount, setZoomAmount] = useState<number>(0);
  const [maxZoom, setMaxZoom] = useState<number>(28);
  const [minZoom, setMinZoom] = useState<number>(0);

  const isAbledZoomIn = zoomAmount < maxZoom;
  const isAbledZoomOut = zoomAmount > minZoom;

  const zoomIn = () => {
    const view = map.getView();
    const currentZoom = view.getZoom() ?? 0;
    if (currentZoom < maxZoom) {
      view.setZoom(currentZoom + 1);
    }
  };

  const zoomOut = () => {
    const view = map.getView();
    const currentZoom = view.getZoom() ?? 0;
    if (currentZoom > minZoom) {
      view.setZoom(currentZoom - 1);
    }
  };

  // 이벤트 리스너 기반으로 zoom/maxZoom/minZoom을 React 상태에 동기화
  useEffect(() => {
    const view = map.getView();

    const syncZoom = () => {
      setZoomAmount(view.getZoom() ?? 0);
      setMaxZoom(view.getMaxZoom());
      setMinZoom(view.getMinZoom());
    };

    // 초기값 동기화
    syncZoom();

    // zoom 변경 감지 (resolution 변경 = zoom 변경)
    view.on("change:resolution", syncZoom);

    const viewPort = map.getViewport();
    const handleWheel = (event: WheelEvent) => {
      event.preventDefault();
      syncZoom();
    };
    viewPort.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      view.un("change:resolution", syncZoom);
      viewPort.removeEventListener("wheel", handleWheel);
    };
  }, [map]);

  return (
    <ControlGroup>
      <Button
        onClick={zoomIn}
        isDisabled={!isAbledZoomIn}
        hasPopup
        popupText={t("mapTool.tool.zoomIn")}
      >
        <InnerButton>
          <ZoomIn size={24} color={isAbledZoomIn ? "black" : "#e2e2e2"} />
        </InnerButton>
      </Button>
      <Button
        onClick={zoomOut}
        isDisabled={!isAbledZoomOut}
        hasPopup
        popupText={t("mapTool.tool.zoomOut")}
      >
        <InnerButton>
          <ZoomOut size={24} color={isAbledZoomOut ? "black" : "#e2e2e2"} />
        </InnerButton>
      </Button>
    </ControlGroup>
  );
};
